export const FedexService = Object.freeze({
  Ground: '50',
  HomeDelivery: '51',
  TwoDay: '52',
  ExpressSaver: '54',
  StandardOvernight: '55',
  PriorityOvernight: '56',
  InternationalEconomy: '59',
  InternationalPriority: '60',
  InternationalFirst: '61',
  SmartPostParcelSelect: '66',
  SmartPostParcelSelectLightWeight: '169',
  InternationalGround: '73',
  ConnectPlus: '4011',
});
